class Accordion {
  constructor(el) {
    this.details = el;
    this.summary = el.querySelector('.summary');
    this.content = el.querySelector('.details__content');

    this.summary.addEventListener('click', (event) => this.onClick(event));
    //this.details.addEventListener('keyup', onKeyUpEscape);
    //window.addEventListener('DOMContentLoaded', this.mobileOnlyDetails());
    //window.addEventListener('resize', () => {
      //this.mobileOnlyDetails();
    //});
  }

  onClick(event) {
    event.preventDefault();
    console.log('this.details')
    console.log(this.details)
    console.log('event')
    console.log(event)
    //event.currentTarget.setAttribute('aria-expanded', !this.details.hasAttribute('open'));


    //if (this.details.hasAttribute('open')) {
    if (this.details.classList.contains('details--active')) {
      this.collapse();
    } else {
      this.expand();
    }

  }

  collapse() {
    this.details.classList.remove('details--active');
    //console.log('collapse')
    //removeTrapFocus();
    // setTimeout(() => {
    //   this.details.removeAttribute('open');
    // }, 500);
  }

  expand() {
    // this.details.setAttribute('open', '');
    setTimeout(() => {
      this.details.classList.add('details--active');
    }, 50);

  }

  //mobileOnlyDetails() {
    //if (this.details.classList.contains('mobile--only') && !this.details.classList.contains('class--shop')) {
      //if (window.innerWidth < 769) {
        //this.collapse();
      //} else {
        //this.expand();
      //}
    //} else if (this.details.classList.contains('mobile--only') && this.details.classList.contains('class--shop')) {
      //this.expand();
    //}
  //}
}
document.querySelectorAll('[id^="Details-"]').forEach((el) => {

  new Accordion(el);
});